export const fixedColumnList = [{
  label:'店铺ID',
  prop:'vendorId',
  numTotal:"",
  width:80,
  fixed:true
},{
  label:'店铺别名',
  prop:'vendorNameAlias',
  numTotal:"",
  width:130,
  fixed:true
},{
  label:'店铺名称',
  prop:'vendorName',
  numTotal:"",
  isSortable:true,
  width:130,
  fixed:true
},{
  label:'国家中文名',
  prop:'addressCountryName',
  width:100,
  numTotal:"",
  fixed:true
},{
  label:'商务运营',
  prop:'boutiqueBD', 
  width:90,
  numTotal:"",
  fixed:true
},{
  label:'运营助理',
  prop:'boutiqueAssistantName', 
  width:90,
  numTotal:"",
  fixed:true
}]

export const leftColumnList = [{
  label:'总订单数',
  prop:'totalOrder',
  isSortable:true,
  width:110,
  numTotal:""
},{
  label:'违约值',
  prop:'orderBreakValueDay',
  isSortable:true,
  width:110,
  numTotal:""
},{
  label:'服务指数',
  prop:'serviceIndex',
  isSortable:true,
  width:110,
  numTotal:""
},{
  label:'累计取消',
  prop:'totalCancelledQtyDay',
  numTotal:"",
  isSortable:true,
  width:120,
},{
  label:'累计取消比',
  prop:'totalCancelProportion',
  width:120,
  numTotal:"",
  isSortable:true,
},{
  label:'累计延迟',
  prop:'totalDelayQtyDay',
  numTotal:"",
  isSortable:true,
  width:120,
},{
  label:'累计延迟比',
  prop:'totalDelayProportion',
  width:130,
  numTotal:"",
  isSortable:true,
}]


export const rightColumnList = [{
  label:'错漏发',
  prop:'errorOrMissQty',
  width:100,
  numTotal:"",
  isSortable:true
},{
  label:'错漏率',
  prop:'errorOrMissQtyProportion',
  width:100,
  numTotal:"",
  isSortable:true
},{
  label:'瑕疵单',
  prop:'flawQty',
  width:100,
  numTotal:"",
  isSortable:true
},{
  label:'瑕疵率',
  prop:'flawQtyProportion',
  width:100,
  numTotal:"",
  isSortable:true
},{
  label:'1天取消',
  prop:'cancelledQtyDay1',
  numTotal:""
},{
  label:'2天取消',
  prop:'cancelledQtyDay2',
  numTotal:""
},{
  label:'3天取消',
  prop:'cancelledQtyDay3',
  numTotal:""
},{
  label:'4天取消',
  prop:'cancelledQtyDay4',
  numTotal:""
},{
  label:'5天取消',
  prop:'cancelledQtyDay5',
  numTotal:""
},{
  label:'6天取消',
  prop:'cancelledQtyDay6',
  numTotal:""
},{
  label:'7天取消',
  prop:'cancelledQtyDay7',
  numTotal:""
},{
  label:'8天+取消',
  prop:'cancelledQtyDay8',
  numTotal:""
},{
  label:'确认后取消',
  prop:'confirmCancelledQty',
  width:100,
  numTotal:""
},{
  label:'延迟1天',
  prop:'delayQtyDay1',
  numTotal:""
},{
  label:'延迟2天',
  prop:'delayQtyDay2',
  numTotal:""
},{
  label:'延迟3天',
  prop:'delayQtyDay3',
  numTotal:""
},{
  label:'延迟4天',
  prop:'delayQtyDay4',
  numTotal:""
},{
  label:'延迟5天',
  prop:'delayQtyDay5',
  numTotal:""
},{
  label:'延迟6天',
  prop:'delayQtyDay6',
  numTotal:""
},{
  label:'延迟7天',
  prop:'delayQtyDay7',
  numTotal:""
},{
  label:'延迟8+天',
  prop:'delayQtyDay8',
  numTotal:""
}]
